import { Drawer, Box, Typography, List, ListItem, ListItemText } from '@mui/material';

const ModuleSidebar = ({ modules, selectedModule, setSelectedModule, colors }) => {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          backgroundColor: colors.primary[400],
        },
      }}
    >
      <Box p={2}>
        <Typography variant="h5">Modules</Typography>
        <List>
          {modules.map((module) => (
            <ListItem 
              sx={{marginBottom: '.3rem', cursor: 'pointer', backgroundColor: '#363636ff', borderBottom: '.1rem solid #ffffff3a'}}
              key={module.id}
              button={true}
              selected={selectedModule === module.id}
              onClick={() => setSelectedModule(module.id)}
            >
              <ListItemText primary={module.module_name} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default ModuleSidebar;